import { render } from "./CalendarWeekAsList.vue?vue&type=template&id=cd9952b4"
import script from "./CalendarWeekAsList.vue?vue&type=script&lang=js"
export * from "./CalendarWeekAsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__